import React from 'react';

export const PdfViewer = ({ fileName }: { fileName: string }) => (
  <div style={{ height: '100vh' }} data-testid='pdf-viewer'>
    <embed data-testid='embedded-pdf' src={fileName} type='application/pdf' width='100%' height='100%' />
  </div>
);
